import { SHEET_TAB_IDS } from "def";
import OptiScore from "pages/Legacy/Marketing/components/OptiScore";
import React from "react";
import AmazonLink from "pages/Legacy/Marketing/components/AmazonLink";
import TdCellEllipsis from "components/Table/TableCells/TdCellEllipsis";
import { formatPrice, formatQuantity } from "Utils";
import { FieldColumnType } from "components/Table/TableHeader/FilterSortCell/d";
import { _getCategoryValueBySheetId } from "helpers";
import { BasePriceHeader, LastDateSoldHeader, SmallHeader, } from "pages/Legacy/Order/365/style";
import OptiscoreHeader from "components/TableHeaders/OptiscoreHeader";
import BasePrice from "pages/Legacy/components/BasePrice";
import Bsr from "pages/Legacy/components/Bsr";
import Order365Category from "pages/Legacy/Order/365/Category";
import RestrictedField from "pages/Legacy/Marketing/components/RestrictedField";

const CategoryFilter = React.lazy(() => import("pages/Legacy/Order/365/Category/CustomFilter"))
const OptiScoreUsed = React.lazy(() => import("pages/Legacy/Marketing/components/OptiScoreUsed"))
const PriceMismatchFilter = React.lazy(() => import("pages/Legacy/components/BasePrice/PriceMismatchFilter"))

export const requestOptions = {}

const Filter = React.lazy(() => import("pages/Legacy/Order/365/Restricted/RestrictedFilter"))

export const RestrictedFieldsHeader = [
    {
        Header: 'RES BG',
        accessor: '15',
        sellerID: 15,
        style: { minWidth: 60 }
    },
    {
        Header: 'RES YOSR',
        accessor: '27',
        sellerID: 27,
        style: { minWidth: 70 }
    }
]


const _RestrictedFields = (restProps: { isUsed?: boolean }) => RestrictedFieldsHeader.map(x => ({
    Header: x.Header,
    accessor: x.accessor,
    canFilter: true,
    canSort: false,
    fieldName: x.accessor,
    sellerId: x.sellerID,
    fieldType: FieldColumnType.multiselectionNum,
    customFilter: Filter,
    style: x.style,
    // style: {
    //     minWidth: 60,
    //     // width: 70,
    //     // maxWidth: 70
    // },
    Cell: (props: any) => <RestrictedField {...props} sellerID={x.sellerID} {...restProps} />
}))

const RestrictedFields = _RestrictedFields({})

// @ts-ignore
export const tableColumns = [

    {
        Header: 'BSR',
        accessor: 'amazonBsr',
        canSort: true,
        canFilter: true,
        align: 'center',
        fieldType: FieldColumnType.number,
        style: {
            minWidth: 75,
            width: 75
        },
        headerStyle: {
            paddingLeft: 10
        },
        Cell: (props: any) => <Bsr row={props.row} />//getAmazonBsr(props.value)
    },
    {
        Header: 'Category',
        accessor: 'category',
        canFilter: true,
        canSort: false,
        fieldType: FieldColumnType.selection,
        align: 'center',
        style: {
            minWidth: 90,
            width: 90,
        },
        Cell: (props: any) => <Order365Category {...props} noUsed={true} />,
        fn: (value: any) => _getCategoryValueBySheetId(value, SHEET_TAB_IDS.SHEET_365_PLUS),
        customFn: true,
        customFilter: CategoryFilter,
        customFilterId: 'sheetIds'
    },
    ...RestrictedFields,
    {
        Header: <OptiscoreHeader code={"USA"} />,
        accessor: 'amazonOptiScore',
        canSort: true,
        canFilter: true,
        fieldType: FieldColumnType.multiselection,
        style: {
            minWidth: 55,
            width: 55,
        },
        Cell: (props: any) => <OptiScore row={props.row} />
    },
    {
        Header: <OptiscoreHeader code={"CAN"} />,
        accessor: 'amazonOptiScoreCA',
        canSort: true,
        canFilter: true,
        fieldType: FieldColumnType.multiselection,
        style: {
            minWidth: 55,
            width: 55
        },
        Cell: (props: any) => <OptiScore isCa row={props.row} />
    },
    {
        Header: 'ASIN',
        accessor: 'asin',
        canFilter: true,
        align: 'center',
        style: {
            minWidth: 110,
            textAlign: 'center'
        },
        canSort: true,
        Cell: (props: any) => <AmazonLink value={props.value} row={props.row} />
    },
    {
        Header: <BasePriceHeader>B.Price</BasePriceHeader>,
        accessor: 'basePrice',
        canSort: true,
        canFilter: true,
        fieldType: FieldColumnType.number,
        align: 'right',
        style: {
            width: 90,
            minWidth: 90,
        },
        Cell: (props: any) => <BasePrice value={props.value} row={props.row} />,
        customFilter: PriceMismatchFilter,
        customFilterId: 'priceMismatch'
    },
    {
        Header: <BasePriceHeader>BB Price</BasePriceHeader>,
        accessor: 'buyboxPrice',
        canSort: true,
        canFilter: true,
        fieldType: FieldColumnType.number,
        align: 'right',
        style: {
            width: 90,
            minWidth: 90,
        },
        Cell: (props: any) => formatPrice(props.value)
    },
    {
        Header: 'Make',
        accessor: 'make',
        canSort: true,
        canFilter: true,
        style: {
            minWidth: 120
        },
        Cell: (props: any) => <TdCellEllipsis {...props} />
    },
    {
        Header: 'Model',
        accessor: 'modelNumber',
        canSort: true,
        canFilter: true,
        style: {
            minWidth: 120
        },
        Cell: (props: any) => <TdCellEllipsis {...props} />
    },
    {
        Header: 'MPN',
        accessor: 'mpn',
        canSort: true,
        canFilter: true,
        style: {
            minWidth: 140,
        },
        Cell: (props: any) => <TdCellEllipsis {...props} />
    },
    {
        Header: 'SKU',
        accessor: 'sku',
        canSort: true,
        canFilter: true,
        style: {
            minWidth: 140,
        },
        Cell: (props: any) => <TdCellEllipsis {...props} />
    },
    {
        Header: 'Last Sold Am. - C',
        accessor: 'lastSoldAmountChannel',
        canSort: false,
        canFilter: false,
        fieldType: FieldColumnType.string,
        align: 'left',
        style: {
            minWidth: 120,
        },
        Cell: (props: any) => <TdCellEllipsis {...props} />
    },
    {
        Header: <LastDateSoldHeader>Last Date Sold</LastDateSoldHeader>,
        accessor: 'lastDateSold',
        canSort: false,
        canFilter: false,
        fieldType: FieldColumnType.onlyDate,
        align: 'center',
        style: {
            minWidth: 100,
        },
        isClearable: true,
        Cell: (props: any) => {
            if (!props?.value) return ''
            const date = props.value.split('-')
            return `${date[1]}/${date[2]}/${date[0].substring(2, 4)}`
        }
    },
    {
        Header: <SmallHeader>QTY</SmallHeader>,
        accessor: 'ytdQuantity',
        canSort: true,
        canFilter: true,
        fieldType: FieldColumnType.number,
        align: 'right',
        style: {
            width: 60,
            minWidth: 60,
        },
        Cell: (props: any) => formatQuantity(props.value)
    },
    {
        Header: 'TOTAL SALES',
        accessor: 'ytdTotalSales',
        canSort: true,
        canFilter: true,
        fieldType: FieldColumnType.number,
        align: 'right',
        style: {
            minWidth: 110
        },
        Cell: (props: any) => formatPrice(props.value)
    },
]

export const fnFilters = {
    category: (value: string) => {
        let obj = {} as any
        if (value.includes('1')) obj.isSecured = 1
        if (value.includes('2')) obj.isUnsecured = 1
        if (value.includes('3')) obj = { isSecured: 1, isUnsecured: 1 }
        if (Object.keys(obj).length) return obj
        return undefined
    },
    ingramId: (value: boolean) => {
        if (!value) return undefined
        return {
            ingramId: {
                $not: null
            }
        }
    },
    // Filter on the category column
    sheetIds: (data: any[]) => {
        console.log("Data: ", data)
        if (!data || !data?.length) return undefined
        if (!Array.isArray(data)) {
            data = [data];
        }
        const TAGGED = 1;
        const RISK = 3;
        const numericData = data.map(x => Number(x)).filter(x => !isNaN(x));
        let filterData: { [key: string]: any } = {};
        filterData.$or = [];
        if (numericData.includes(RISK)) {
            filterData.$or.push({ riskQuantity: { $gt: 0 } })
        }
        if (numericData.includes(TAGGED)) {
            filterData.$or.push({ ebayCount: { $gt: 0 } });
            filterData.$or.push({ fbModelCount: { $gt: 0 } });
            filterData.$or.push({ fbMpnCount: { $gt: 0 } })
        }
        let securedData = numericData.filter(x => x > 60);
        // for (const sheet of securedData) {
        //     filterData.$or.push({ sheetIds: { $like: `%${sheet}%` } })
        // }
        // The most accurate code for what we want is above.
        // However, I've only ever seen the team click all the secured categories at once.
        // So the code below is way faster and more simple, and I doubt the team will notice the difference.
        // If they do, I'll change it. Whatever.
        if (securedData.length) {
            filterData.$or.push({ sheetIds: { $like: '%225%' } })
            filterData.$or.push({ sheetIds: { $like: '%226%' } })
        }
        console.log("Filter is this: ", filterData);
        return filterData;
    },
    priceMismatch: (value: any) => {
        if (!value) return undefined
        return { priceMismatch: 1 }
    }
}
